import React from "react";
import "./Activitse.css";
import LoadingSkeleton from "./LoadingSkeleton";
import OfflineMeetupActivity from "./OffineMeetupActivity";
import SingleActivity from "./SingleActivity";

const ActivitiesContent = (props) => {
  return (
    <>
      <div className="row mt-3">
        {true ? (
          props.event.map((event) => {
            return (
              <>
                {event.meetup_event?.meetup_type === "Offline" ? (
                  <OfflineMeetupActivity
                    event={event.meetup_event}
                    event_type="meetup"
                  ></OfflineMeetupActivity>
                ) : (
                  <SingleActivity
                    eventData={event}
                    event={event.meetup_event}
                    event_type="meetup"
                  ></SingleActivity>
                )}
              </>
            );
          })
        ) : (
          <LoadingSkeleton />
        )}
      </div>
    </>
  );
};

export default ActivitiesContent;
